import { createApp } from "vue";
import App from "./App.vue";
import router from "@/routers";
import pinia from "@/stores";
// css
import "@/assets/styles/element.scss";
import "zhihao-ui/dist/index.css";
import "@/assets/styles/default.scss";
import "@/assets/styles/_spacing.scss";
import "@/assets/iconfont/iconfont.css";
import "@/assets/styles/tailwind.css";
// custom directives
import directives from "@/views/directives/index";
import * as preComp from "@/utils/preComp";
import { ElLoading } from "element-plus";

const app = createApp(App);

Object.keys(preComp).forEach(key => {
    app.component(key, preComp[key as keyof typeof preComp]);
});
app.directive("loading", ElLoading.directive);
app.use(directives).use(pinia).use(router).mount("#app");
